// @flow

import { connect } from 'react-redux';

import { Header as PlatformHeader } from '@zapier/product-dev-platform';
import { RouterSelectors } from '@zapier/toolbox-redux-framework';

import { Profile } from '@zapier/shared-entities';

import type { HeaderUser } from '@zapier/product-dev-platform';

const mapStateToProps = state => {
  const isLoggedIn = Profile.selectors.all.isLoggedIn(state);
  const currentProfile = Profile.selectors.all.currentProfile(state);
  const user: ?HeaderUser = isLoggedIn
    ? {
        name: Profile.selectors.normalizedName(currentProfile) || '',
        avatarUrl: Profile.selectors.gravatarUrl(currentProfile),
      }
    : null;

  return {
    currentUrl: RouterSelectors.currentUrl(state) || '',
    user,
  };
};

export default connect(mapStateToProps)(PlatformHeader);
